// models
import InstanceLink from './models/instance/InstanceLink';

// library
import deleteInstanceLinks from './library/deleteInstanceLinks';
import deleteInstancesSurveysResponses from './library/deleteInstancesSurveysResponses';
import getInstanceLinks from './library/getInstanceLinks';
import getInstances from './library/getInstances';
import getInstancesQuestions from './library/getInstancesQuestions';
import getInstancesQuestionsOptions from './library/getInstancesQuestionsOptions';
import getInstancesResponses from './library/getInstancesResponses';
import getLoginStatus from './library/getLoginStatus';
import getLoginStatuses from './library/getLoginStatuses';
import getProfiles from './library/getProfiles';
import getProfileVO from './library/getProfileVO';
import login from './library/login';
import logout from './library/logout';
import postPasswordReset from './library/postPasswordReset';
import postPutInstanceLinks from './library/postPutInstanceLinks';
import postPutSurveyResponsesNoCache from './library/postPutSurveyResponsesNoCache';
import putProfile from './library/putProfile';
import putUserPassword from './library/putUserPassword';
import postNotificationsEmailsForEmailTemplate from './library/postNotificationsEmailsForEmailTemplate';
import postUserPasswordWithToken from './library/postUserPasswordWithToken';

// utils
import getResponseKey from './utils/getResponseKey';

const models = {
  InstanceLink
};

const utils = {
  getResponseKey
};

const sdk = {
  deleteInstanceLinks,
  deleteInstancesSurveysResponses,
  getInstanceLinks,
  getInstances,
  getInstancesQuestions,
  getInstancesQuestionsOptions,
  getInstancesResponses,
  getLoginStatus,
  getLoginStatuses,
  getProfiles,
  getProfileVO,
  login,
  logout,
  postPasswordReset,
  postPutSurveyResponsesNoCache,
  postPutInstanceLinks,
  putProfile,
  putUserPassword,
  models,
  postNotificationsEmailsForEmailTemplate,
  postUserPasswordWithToken,
  utils
};

export default sdk;



// WEBPACK FOOTER //
// ./src/qoc-sdk/index.js